import { render, staticRenderFns } from "./SaveReportWizardUnderwriter.vue?vue&type=template&id=0edccca6"
import script from "./SaveReportWizardUnderwriter.vue?vue&type=script&lang=js"
export * from "./SaveReportWizardUnderwriter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports